import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Hook pour gérer la redirection automatique vers l'onglet statistics
 * quand aucun onglet n'est spécifié dans l'URL
 */
export const useAnalysisTabRedirect = (analysisId: string) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!analysisId) return;

    const pathSegments = location.pathname.split('/');
    const analysisType = pathSegments[2]; // 'products', 'vendors', ou 'public'

    // Si on est sur /analysis/:type/:id sans onglet, rediriger vers statistics
    if (location.pathname === `/analysis/${analysisType}/${analysisId}`) {
      navigate(`/analysis/${analysisType}/${analysisId}/tab/statistics`, { replace: true });
    }
  }, [location.pathname, analysisId, navigate]);
};
